// Note: The duration string input and the amount returned shouldn't be strings that the user can see, but they should be $getLocale keys.
// Otherwise this pluralization would work only for English (and not even for irregular cases).
export const pluralizeDuration = (amount, duration) => {
    const durationTrim = duration.trim();

    return amount > 1 && !durationTrim.endsWith('s') ? (duration += 's') : duration;
};
